import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Tlearning } from '../type/learning';
import { postDataPages } from '../service/learningService';
import { showMessage } from '../utls/message';

export interface learningsSlice {
	learningsPage: Tlearning[];
	totalRows: number;
	pageNo: number;
	pageSize: number;
}

const initialState: learningsSlice = {
	learningsPage: [],
	totalRows: 0,
	pageNo: 0,
	pageSize: 10,
};

export const postDataPage = createAsyncThunk(
	'learning/filter',
	async (data: any) => {
		const response = await postDataPages(data);
		if (response?.code === 200 && !response.error) {
			return response.data;
		} else {
			showMessage(`${response?.code} ${response?.message}`, 'danger');
			return initialState;
		}
	}
);

const learningsSlice = createSlice({
	name: 'learnings',
	initialState,
	reducers: {
		setPageNo: (state, action) => {
			state.pageNo = action.payload;
		},
		setPageSize: (state, action) => {
			state.pageSize = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(postDataPage.fulfilled, (state, action) => {
			if (action.payload.content) {
				state.learningsPage = action.payload.content;
				state.totalRows = action.payload.totalElements;
			} else {
				state.learningsPage = [];
				state.totalRows = 0;
			}
		});
	},
});

export const { setPageNo, setPageSize } = learningsSlice.actions;
export default learningsSlice.reducer;
